import type React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { Footer } from '#admin/component/Footer.tsx';
import { Header } from '#admin/component/Header.tsx';
import { isBridgeScopedSession } from '#admin/helpers.ts';
import type { RootState } from '#admin/store.ts';

export const Layout: React.FC = () => {
  const token = useSelector((state: RootState) => state.app.token);
  const isAuthenticated = !!token;
  const location = useLocation();

  const isPublicPage = ['/verify'].includes(location.pathname);
  const isBridgeSession = isBridgeScopedSession(token);

  return (
    <>
      {isAuthenticated && !isPublicPage && !isBridgeSession && <Header />}
      <Outlet />
      {!isBridgeSession && <Footer />}
    </>
  );
};
